import { FaCheckCircle } from "react-icons/fa";
import {
  createColumnHelper,
} from '@tanstack/react-table';

const columnHelper = createColumnHelper();
const columns = (openModal, t, appointmentsSelected, handleUpdateAppointments) => [
  columnHelper.accessor('carrierString', {
    cell: info => info.getValue(),
    header: () => <span>{t("planAssignment.service")}</span>,
  }),
  columnHelper.accessor('id', {
    cell: info => info.getValue(),
    header: () => <span>{t("planAssignment.columnId")}</span>,
  }),
  columnHelper.accessor('shPt', {
    cell: info => info.getValue(),
    header: () => <span>{t("planAssignment.columnOrigen")}</span>,
  }),
  columnHelper.accessor('shipTo', {
    cell: info => info.getValue(),
    header: () => <span>{t("planAssignment.mColunDestination")}</span>,
  }),
  columnHelper.accessor('dv', {
    cell: info => info.getValue(),
    header: () => <span>{t("planAssignment.columnTypeService")}</span>,
  }),
  columnHelper.accessor('pU_AppointmentDay', {
    cell: info => info.getValue(),
    header: () => <span>{t("planAssignment.columnAppointmentDate")}</span>,
  }),
  columnHelper.accessor('create', {
    cell: info =>{
      const value = info.row.original;
      const isSelected = appointmentsSelected.some((appointment) => appointment.id === value.id);
  
      return (
        <div className='w-full flex justify-center items-center'>
          {isSelected ? (
            <FaCheckCircle 
              className='w-8 h-8 text-black cursor-pointer' 
              onClick={()=> handleUpdateAppointments(value, 'remove')} 
            />
          ) : (
            <div 
              className='w-8 h-8 border-2 border-gray-800 rounded-full hover:bg-gray-400 cursor-pointer'
              onClick={()=> handleUpdateAppointments(value, 'add')} 
            />
          )}
        </div>
      )
      
    },
    header: () => <button
      className={`w-28 h-10 p-2 ${appointmentsSelected.length > 0 ? 'bg-[#337bcf]' : 'bg-gray-500' }  text-white rounded-lg cursor-pointer`}
      onClick={openModal}
      disabled={appointmentsSelected.length === 0}
    >
      {t("planAssignment.generateButton")}
    </button>,
  }),
]

export default columns;